import { ApplicationStatus } from '@/apis/family_application/requests'
import { AppRoutePaths } from '@/routing/route_paths'

const {
  assessments,
  marketplace,
  payments,
  reimbursements,
  notifications,
  external,
} = AppRoutePaths

const NEW_APPLICANT_EXCLUDED_PAGES = [
  external.classWallet,
  assessments.index,
  // marketplace.index,
  notifications.index,
]

export const EXCLUDED_PAGES_PER_STATUS: Record<ApplicationStatus, string[]> = {
  // NEW APPLICANTS WITHOUT SCHOLARSHIP
  Invited: NEW_APPLICANT_EXCLUDED_PAGES,
  Eligible: NEW_APPLICANT_EXCLUDED_PAGES,
  Pending: NEW_APPLICANT_EXCLUDED_PAGES,
  Complete: NEW_APPLICANT_EXCLUDED_PAGES,
  Ineligible: NEW_APPLICANT_EXCLUDED_PAGES,
  Withdrawn: NEW_APPLICANT_EXCLUDED_PAGES,
  'In Review': NEW_APPLICANT_EXCLUDED_PAGES,
  'In Progress': NEW_APPLICANT_EXCLUDED_PAGES,
  'Wait Listed': NEW_APPLICANT_EXCLUDED_PAGES,
  'V1 Invited': [],
  // NEW APPLICANTS WITH SCHOLARSHIP

  Awarded: [],
  Appeal: [],
  Funded: [],
  // RENEWAL APPLICANT
  'ClassWallet Renewal': [
    marketplace.index,
    payments.index,
    reimbursements.index,
  ],

  'Age Phase Out': [],
  // SOFTPOINT RENEWAL APPLICANT
  'SoftPoint Renewal': [],
} as const
